export const dayOfWeekOptions = [
  { key: "sunday", label: "Sunday", shortLabel: "SUN" },
  { key: "monday", label: "Monday", shortLabel: "MON" },
  { key: "tuesday", label: "Tuesday", shortLabel: "TUE" },
  { key: "wednesday", label: "Wednesday", shortLabel: "WED" },
  { key: "thursday", label: "Thursday", shortLabel: "THU" },
  { key: "friday", label: "Friday", shortLabel: "FRI" },
  { key: "saturday", label: "Saturday", shortLabel: "SAT" },
];

export const scheduleProfileType = {
  wireless: "wireless",
  wired: "wired",
};

export const defaultScheduleDays = [
  { dayOfWeek: "sunday", enabled: true, from: "00:00", to: "24:00" },
  { dayOfWeek: "monday", enabled: true, from: "00:00", to: "24:00" },
  { dayOfWeek: "tuesday", enabled: true, from: "00:00", to: "24:00" },
  { dayOfWeek: "wednesday", enabled: true, from: "00:00", to: "24:00" },
  { dayOfWeek: "thursday", enabled: true, from: "00:00", to: "24:00" },
  { dayOfWeek: "friday", enabled: true, from: "00:00", to: "24:00" },
  { dayOfWeek: "saturday", enabled: true, from: "00:00", to: "24:00" },
];

export const defaultScheduleProfile = {
  id: null,
  name: "",
  profileType: scheduleProfileType.wireless,
  displayFormat: "24-hour",
  days: defaultScheduleDays,
};

export const scheduleActionState = {
  idle: "idle",
  create: "create",
  edit: "edit",
  remove: "remove",
};
